import React from 'react';
import { View } from 'react-native';
import BigParagraphWithIconLine from '../../../AuxiliaryComponent/BigParagraphWithIconLine';
import FullPageSimulator from '../../FullPageSimulator';
import LargeBtnWithFilling from '../../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import { two_hundred_dollars, Resend_SMS } from '../../../../../utils/DictionaryManagementUtils';
//= ========================================================================

const ConfirmActionFP = ({
  globJSON,
  simPlatform,
  subCategoryId,
  headlineText,
  TopTitle,
  stringBottom,
  slideshowRefs = null,
}) => (
  <FullPageSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    headlineText={headlineText}
    TopTitle={TopTitle}
    slideshowRefs={slideshowRefs}
  >
    <BigParagraphWithIconLine
      globJSON={globJSON}
      simPlatform={simPlatform}
      stringButtom={stringBottom}
      withoutIconLine
      withOutLink
      onlyUserDetails
      price={two_hundred_dollars}
    />
    <LargeBtnWithFilling
      globJSON={globJSON}
      simPlatform={simPlatform}
      subCategoryId={subCategoryId}
      inputText={Resend_SMS}
    />
    <View style={{ width: 1, height: 10 }} />
  </FullPageSimulator>

);
export default ConfirmActionFP;
